import {
  AnalyticsEvent,
  EventParameters,
} from "@adsk/acc-issues-core/utils/analytics/analyticsTypes";

export class IssueEditBulkEditPublishEvent implements AnalyticsEvent {
  name = "issue.edit.bulk_edit.publish";
  parameters: EventParameters;

  constructor(params: { selectedCount: number }) {
    this.parameters = {
      ...params,
    };
  }
}
